module.exports = __webpack_public_path__ + "static/img/loading.c288cc3.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/loading.gif
// module id = 4cF/
// module chunks = 1